import { Component, OnInit } from "@angular/core";
import { CatVencimientos_Service } from "../../servicios/cat-vencimientos.service";
import { CatAguaZonasService } from "../../servicios/cat-agua-zonas.service";
import { CatTipoPeriodosService } from "../../servicios/cat-tipo-periodos.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { CatVencimientos_ } from "../../entidades/entidades";
import { CatAguaZonas } from "../../entidades/entidades";
import { CatTipoPeriodos } from "../../entidades/entidades";
@Component({
  selector: "app-cat-vencimientos-grid",
  templateUrl: "./cat-vencimientos-grid.component.html",
  styleUrls: ["./cat-vencimientos-grid.component.css"],
})
export class CatVencimientos_GridComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  catAguaZonas: SelectItem[];
  catTipoPeriodos: SelectItem[];
  catVencimientos: CatVencimientos_[];
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  clonedCatVencimientos: { [s: string]: CatVencimientos_ } = {};

  constructor(
   private catVencimientosService: CatVencimientos_Service,
    private catAguaZonasService: CatAguaZonasService,
    private catTipoPeriodosService: CatTipoPeriodosService,
  ) {}

  ngOnInit(): void {
this.getAllCatAguaZonas();
this.getAllCatTipoPeriodos();
    this.getAllCatVencimientos();

    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [
      {label: "Agregar",   icon: "pi pi-file-o",  command: () => this.add(), },
      {label: "Guardar",   icon: "pi pi-save",    command: (event) => {this.guardarGridCatVencimientos();} },
      {label: "Refrescar", icon: "pi pi-refresh", command: (event) => {this.getAllCatVencimientos();} },
    ];

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      {field: "operacion",header: "Editar", ordenar: false, styleHeader: "width: 60px;"},
      {field: "idAguaZona", header: "Agua Zona",ordenar: true, styleHeader: "width: 200px;",},
      {field: "idTipoPeriodo", header: "Tipo Periodo",ordenar: true, styleHeader: "width: 200px;",},
      {field: "anio", header: "Anio",ordenar: true, styleHeader: "width: 150px;",},
      {field: "periodoParcialidad", header: "Periodo Parcialidad",ordenar: true, styleHeader: "width: 150px;",},
      {field: "tomaLecturaIni", header: "Toma Lectura Ini",ordenar: true, styleHeader: "width: 150px;",},
      {field: "tomaLecturaFin", header: "Toma Lectura Fin",ordenar: true, styleHeader: "width: 150px;",},
      {field: "capturaIni", header: "Captura Ini",ordenar: true, styleHeader: "width: 150px;",},
      {field: "capturaFin", header: "Captura Fin",ordenar: true, styleHeader: "width: 150px;",},
      {field: "impresionIni", header: "Impresion Ini",ordenar: true, styleHeader: "width: 150px;",},
      {field: "impresionFin", header: "Impresion Fin",ordenar: true, styleHeader: "width: 150px;",},
      {field: "facturacionIni", header: "Facturacion Ini",ordenar: true, styleHeader: "width: 150px;",},
      {field: "facturacionFin", header: "Facturacion Fin",ordenar: true, styleHeader: "width: 150px;",},
      {field: "entregaIni", header: "Entrega Ini",ordenar: true, styleHeader: "width: 150px;",},
      {field: "entregaFin", header: "Entrega Fin",ordenar: true, styleHeader: "width: 150px;",},
      {field: "fechaVencimiento", header: "Fecha Vencimiento",ordenar: true, styleHeader: "width: 150px;",},
      //{field: "acciones", header: "Eliminar",ordenar: false, styleHeader: "width: 70px;",},
    ];
  }
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  // prettier-ignore
  add() {
    let catVencimientosNew = new CatVencimientos_();
    catVencimientosNew.cambio = true;
    catVencimientosNew.id = 0;
    catVencimientosNew.numRow = this.catVencimientos.length + 1;
    this.catVencimientos.unshift(catVencimientosNew);
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  // prettier-ignore
  onEditInit(event) {
    let catVencimientosEdit = event.data;
    this.clonedCatVencimientos[catVencimientosEdit.numRow] = { ...catVencimientosEdit };
    catVencimientosEdit.cambio = true;
    catVencimientosEdit.baja = false;
  }

  // prettier-ignore
  onEditCancel(event) {
    let catVencimientosEdit = event.data;
    let index = this.catVencimientos.findIndex(
      (obj) => obj.numRow === catVencimientosEdit.numRow
    );
    this.catVencimientos[index] = { ...this.clonedCatVencimientos[catVencimientosEdit.numRow]};
  }

  // prettier-ignore
  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
  }

  // prettier-ignore
  async onEditComplete(event) {
    try {
      let catVencimientosEdit = event.data;

      //Valida si hay cambios
      if (
        catVencimientosEdit.id === this.clonedCatVencimientos[catVencimientosEdit.numRow].id &&
        catVencimientosEdit.idAguaZona === this.clonedCatVencimientos[catVencimientosEdit.numRow].idAguaZona &&
        catVencimientosEdit.idTipoPeriodo === this.clonedCatVencimientos[catVencimientosEdit.numRow].idTipoPeriodo &&
        catVencimientosEdit.anio === this.clonedCatVencimientos[catVencimientosEdit.numRow].anio &&
        catVencimientosEdit.periodoParcialidad === this.clonedCatVencimientos[catVencimientosEdit.numRow].periodoParcialidad &&
        catVencimientosEdit.tomaLecturaIni === this.clonedCatVencimientos[catVencimientosEdit.numRow].tomaLecturaIni &&
        catVencimientosEdit.tomaLecturaFin === this.clonedCatVencimientos[catVencimientosEdit.numRow].tomaLecturaFin &&
        catVencimientosEdit.capturaIni === this.clonedCatVencimientos[catVencimientosEdit.numRow].capturaIni &&
        catVencimientosEdit.capturaFin === this.clonedCatVencimientos[catVencimientosEdit.numRow].capturaFin &&
        catVencimientosEdit.impresionIni === this.clonedCatVencimientos[catVencimientosEdit.numRow].impresionIni &&
        catVencimientosEdit.impresionFin === this.clonedCatVencimientos[catVencimientosEdit.numRow].impresionFin &&
        catVencimientosEdit.facturacionIni === this.clonedCatVencimientos[catVencimientosEdit.numRow].facturacionIni &&
        catVencimientosEdit.facturacionFin === this.clonedCatVencimientos[catVencimientosEdit.numRow].facturacionFin &&
        catVencimientosEdit.entregaIni === this.clonedCatVencimientos[catVencimientosEdit.numRow].entregaIni &&
        catVencimientosEdit.entregaFin === this.clonedCatVencimientos[catVencimientosEdit.numRow].entregaFin &&
        catVencimientosEdit.fechaVencimiento === this.clonedCatVencimientos[catVencimientosEdit.numRow].fechaVencimiento 
      ) {
        let index = this.catVencimientos.findIndex((obj) => obj.numRow === catVencimientosEdit.numRow);
        this.catVencimientos[index] = {...this.clonedCatVencimientos[catVencimientosEdit.numRow]};
        return;
      }

      //Validaciones
      //throw new Error("No paso las validaciones.");

      catVencimientosEdit.cambio = true;
      catVencimientosEdit.baja = false;
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }
  //===============================================================
  //Interaccion con servicios
  //===============================================================
  // prettier-ignore
  async guardarGridCatVencimientos() {
    try {
      for (let catVencimientosFor of this.catVencimientos) {
        if (catVencimientosFor.baja) {
          await this.deleteCatVencimientos(catVencimientosFor);
        } else if (catVencimientosFor.cambio) {
          catVencimientosFor.cambio = false;
          this.clonedCatVencimientos[catVencimientosFor.id] = { ...catVencimientosFor, };
          if (catVencimientosFor.id === 0) {
            const datoRetorno = await this.addCatVencimientos(catVencimientosFor);
            catVencimientosFor.id = datoRetorno.id;
          } else {
            await this.updateCatVencimientos(catVencimientosFor);
          }
        }
      }

      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarCatVencimientos");
    }
  }

  // prettier-ignore
  async addCatVencimientos(catVencimientos) {
    try {
      const datoretorno = await this.catVencimientosService
        .add(catVencimientos)
        .toPromise();
      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addCatVencimientos");
    }
  }

  // prettier-ignore
  async getAllCatVencimientos() {
    try {
      const datoRetorno = await this.catVencimientosService.getAll().toPromise();
      for (var i = 0, len = datoRetorno.length; i < len; ++i){
        datoRetorno[i].tomaLecturaIni = new Date(datoRetorno[i].tomaLecturaIni);
        datoRetorno[i].tomaLecturaFin = new Date(datoRetorno[i].tomaLecturaFin);
        datoRetorno[i].capturaIni = new Date(datoRetorno[i].capturaIni);
        datoRetorno[i].capturaFin = new Date(datoRetorno[i].capturaFin);
        datoRetorno[i].impresionIni = new Date(datoRetorno[i].impresionIni);
        datoRetorno[i].impresionFin = new Date(datoRetorno[i].impresionFin);
        datoRetorno[i].facturacionIni = new Date(datoRetorno[i].facturacionIni);
        datoRetorno[i].facturacionFin = new Date(datoRetorno[i].facturacionFin);
        datoRetorno[i].entregaIni = new Date(datoRetorno[i].entregaIni);
        datoRetorno[i].entregaFin = new Date(datoRetorno[i].entregaFin);
        datoRetorno[i].fechaVencimiento = new Date(datoRetorno[i].fechaVencimiento);
      }
      this.catVencimientos = datoRetorno;
      for (var i = 0, len = this.catVencimientos.length; i < len; ++i){
        this.catVencimientos[i].numRow = i;
        this.clonedCatVencimientos[this.catVencimientos[i].numRow] = {...this.catVencimientos[i],        };
      } 
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCatVencimientos");
    }
  }

  // prettier-ignore
  async updateCatVencimientos(catVencimientos: CatVencimientos_) {
    try {
      const datoRetorno = await this.catVencimientosService
        .update(catVencimientos)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateCatVencimientos");
    }
  }

  // prettier-ignore
  async deleteCatVencimientos(catVencimientos: CatVencimientos_) {
    try {
      const datoRetorno = await this.catVencimientosService
        .delete(catVencimientos.id)
        .toPromise();
      this.getAllCatVencimientos();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteCatVencimientos");
    }
  }

  // prettier-ignore
  async getAllCatAguaZonas() {
    try {
      const datoRetorno = await this.catAguaZonasService.getAll().toPromise();
      this.catAguaZonas = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catAguaZonas.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatAguaZonas");
    }
  }

  // prettier-ignore
  async getAllCatTipoPeriodos() {
    try {
      const datoRetorno = await this.catTipoPeriodosService.getAll().toPromise();
      this.catTipoPeriodos = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catTipoPeriodos.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatTipoPeriodos");
    }
  }
}